<template>
  <div id="app">
    <commonhead
      :active_menu="0"
      :show_type="showtype"
      :bg="bg"
      :mobile="mobile"
      :callback="headcallback"
      :switch="headswitch"
    />
    <!-- 侧边悬浮 -->
    <div class="contact_way">
      <div
        class="contact_item contact_item1"
        @mouseover="showServicer"
        @mouseleave="hideServicer"
      >
        <div class="icon icon-wechat"></div>
        <div class="contact_text">服务号</div>
      </div>
      <div class="contact_item contact_item2">
        <div class="icon icon-tel"></div>
        <div class="contact_text">电话咨询</div>
      </div>
      <div class="contact_item contact_item3" @click="show_talk">
        <div class="icon icon-service"></div>
        <div class="contact_text">在线咨询</div>
      </div>
      <div class="contact_servicer" v-show="show_servicer">
        <img
          src="../../assets/image/common/new/qrcode_258.jpg"
          class="pic_full"
        />
      </div>
    </div>
    <div class="index">
      <div class="bannerbox">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in swiperArr"
              :key="index"
            >
              <div class="banner" :class="'banner_' + index"></div>
            </div>
          </div>
          <div class="swiper-button-next swiper-button-white"></div>
          <div class="swiper-button-prev swiper-button-white"></div>
        </div>
        <!-- <swiper :options="swiperOption">
          <swiper-slide class="swiper-slide" v-for="(item,index) in swiperArr" :key="index">
            <div class="banner" :class="'banner_'+index"></div>          
          </swiper-slide>
        </swiper> -->
      </div>
      <!-- <div class="banner"></div> -->
      <!-- 简介 -->
      <div class="content_info">
        <div class="info_item info_video">
          <video src=""></video>
          <!-- <div class="video_control"></div> -->
        </div>
        <div class="info_item info_text">
          英语试卷满分，不一定能说好英语；<br />说好英语，成绩一定不会差：<br />鲸贝，专注于英语启蒙素质教育。
        </div>
      </div>
      <!-- 特色 -->
      <div class="feature_titlebox margin_top90">
        <div class="feature_title">鲸贝特色</div>
        <div class="feature_subtitle">个性化定制学习内容</div>
      </div>
      <div class="feature_items">
        <div class="feature_item">
          <img
            src="../../assets/image/index/new/feature_1.png"
            alt="科技驱动与定制化"
            class="pic_full"
          />
          <div class="feature_text">科技驱动与定制化</div>
          <div class="feature_line"></div>
          <div class="feature_content">
            互联网、大数据、AI等科技支撑，为每个学员单独建立动态学习数据档案，因材施教，有侧重教学。
          </div>
        </div>
        <div class="feature_item item_shadow">
          <img
            src="../../assets/image/index/new/feature_2.png"
            alt="教学"
            class="pic_full"
          />
          <div class="feature_text">教学</div>
          <div class="feature_line"></div>
          <div class="feature_content">
            国内外一流高校优秀教育专家独创“悉得”教学方法，在孩子度过“静默期”后，拥有英语思维能力、运用能力和国际视野。
          </div>
        </div>
      </div>
      <div class="feature_items">
        <div class="feature_item">
          <img
            src="../../assets/image/index/new/feature_3.png"
            alt="服务"
            class="pic_full"
          />
          <div class="feature_text">教学</div>
          <div class="feature_line"></div>
          <div class="feature_content">
            秉承“热情主动”的理念，专属助教定时跟踪学习进度，在线客服及时响应遇到的问题。
          </div>
        </div>
        <div class="feature_item">
          <img
            src="../../assets/image/index/new/feature_4.png"
            alt="体验"
            class="pic_full"
          />
          <div class="feature_text">体验</div>
          <div class="feature_line"></div>
          <div class="feature_content">
            免费试听。预习，上课，复习智能闭环学习路径。学生、家长和老师三向反馈
          </div>
        </div>
      </div>
      <div class="teacher_features"></div>
      <div class="feature_titlebox margin_top80">
        <div class="feature_title">课程亮点</div>
        <div class="feature_subtitle">只做最专业的教学</div>
      </div>
      <div class="highlight_items margin_top50">
        <div class="highlight_item">
          <img
            src="../../assets/image/index/new/highlight_1.png"
            alt="优秀教育专家"
            class="pic_full"
          />
          <div class="highlight_content">
            国内外优秀教育专家主导，“悉得”教学方法，反<br />复打磨的专业课程
          </div>
        </div>
        <div class="highlight_item">
          <img
            src="../../assets/image/index/new/highlight_2.png"
            alt="智能闭环"
            class="pic_full"
          />
          <div class="highlight_content">
            预习、上课、复习组成智能闭环学习路径。孩子动<br />态学习数据档案，孩子、家长、老师三向反馈体系
          </div>
        </div>
        <div class="highlight_item">
          <img
            src="../../assets/image/index/new/highlight_3.png"
            alt="因材施教"
            class="pic_full"
          />
          <div class="highlight_content">
            因材施教，根据学会数据反馈，进行个性化、定<br />制化教学
          </div>
        </div>
      </div>
      <div class="goal_block margin_top80">
        <div class="feature_titlebox">
          <div class="feature_title">鲸贝目标</div>
          <div class="feature_subtitle">用英语赋予孩子国际竞争力</div>
        </div>
        <div class="goal_items">
          <div class="goal_item goal_item1">
            <div class="goal_box">
              <div class="goal_head">
                <img src="../../assets/image/index/new/LV_1.png" alt="" />
                <span class="goal_title">开口表达</span>
              </div>
              <div class="goal_content">
                熟练掌握英文基础和日常生活会话，培养兴趣，建立语感
              </div>
            </div>
          </div>
          <div class="goal_item goal_item2">
            <div class="goal_box">
              <div class="goal_head">
                <img src="../../assets/image/index/new/LV_2.png" alt="" />
                <span class="goal_title">简单阅读</span>
              </div>
              <div class="goal_content">
                听说读写全面锻炼提升，让孩子具备使用英语进行日常生活学习的沟通能力
              </div>
            </div>
          </div>
          <div class="goal_item goal_item3">
            <div class="goal_box">
              <div class="goal_head">
                <img src="../../assets/image/index/new/LV_3.png" alt="" />
                <span class="goal_title">场景对话</span>
              </div>
              <div class="goal_content">
                不局限于书本上的知识点，建立英文思维，让孩子具备结合生活见闻、使用英语复杂句对话的能力
              </div>
            </div>
          </div>
          <div class="goal_item goal_item4">
            <div class="goal_box">
              <div class="goal_head">
                <img src="../../assets/image/index/new/LV_4.png" alt="" />
                <span class="goal_title">运用自如</span>
              </div>
              <div class="goal_content">
                能够用英文表达完整逻辑思维，达到英文类似于第二母语的状态，让孩子具备可以用英文和外教探讨学科问题的能力
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="feature_titlebox margin_top80">
        <div class="feature_title">免费试听</div>
        <div class="feature_subtitle">英语启蒙，我们是专业的</div>
      </div>
      <div class="free_items">
        <div class="free_item">
          <img src="../../assets/image/index/new/free_1.png" alt="" />
          <div class="free_content">在线注册，并领取试听课</div>
        </div>
        <div class="free_item">
          <img src="../../assets/image/index/new/free_2.png" alt="" />
          <div class="free_content">专属助教联系您，确定上课时间</div>
        </div>
        <div class="free_item">
          <img src="../../assets/image/index/new/free_3.png" alt="" />
          <div class="free_content">
            检查设备和网络并提前预习<br />开始一对一外教上课
          </div>
        </div>
      </div>
      <div class="online-register" @click="register">在线注册免费试听</div>
      <div class="feature_titlebox margin_top80">
        <div class="feature_title">鲸贝承诺</div>
        <div class="feature_subtitle">鲸贝英语向每一位用户郑重承诺</div>
      </div>
      <div class="promise_block">
        <div class="promise_img"></div>
        <div class="promise_items">
          <div class="promise_item">
            <div class="promise-icon promise-icon1"></div>
            <div class="promise_info">
              <div class="promise_title">无忧退费</div>
              <div class="promise_content">
                对首次购买的课程不满意，在开课7天内，可提出“无条件<br />退款”申请。
              </div>
            </div>
          </div>
          <div class="promise_item">
            <div class="promise-icon promise-icon2"></div>
            <div class="promise_info">
              <div class="promise_title">教学承诺</div>
              <div class="promise_content">
                鲸贝英语保证外教拥有国际教学从业资格TESOL或TEFL。<br />保证严格面试和培训。同时在教研上一直进步。
              </div>
            </div>
          </div>
          <div class="promise_item">
            <div class="promise-icon promise-icon3"></div>
            <div class="promise_info">
              <div class="promise_title">服务承诺</div>
              <div class="promise_content">
                鲸贝英语向付费学员签订课程服务协议，保障后续的服务<br />水平。
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--底部信息-->
      <div class="bottombox" v-if="!login_status">
        <commonbottomNotlogin
          :detectscroll="detectscroll"
          :register="register"
          :mobilechange="mobilechange"
        />
      </div>
      <div class="bottomloginbox" v-if="login_status">
        <commonbottom :detectscroll="detectscroll" />
      </div>
      <!--公共底部-->
      <commonfoot />
      <!--公共底部-->
    </div>
  </div>
</template>

<script>
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import commonbottomNotlogin from "../common/common_bottom_notlogin";
import commonbottom from "../common/common_bottom";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min.js";
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
    commonbottomNotlogin,
    commonbottom,
  },
  data() {
    return {
      bg: "",
      login_status: false,
      show_servicer: false,
      swiperArr: [0, 1],
      mobile: "",
      detectscroll: true,
      showtype: 2,
    };
  },
  methods: {
    register(mobile) {
      this.showtype = 2;
      this.mobile = mobile;
      this.bg = Math.random();
    },
    loginStatus(isLogin) {
      this.login_status = isLogin;
    },
    showServicer() {
      this.show_servicer = true;
    },
    hideServicer() {
      this.show_servicer = false;
    },
    show_talk() {
      _MEIQIA("showPanel");
    },
    headcallback(res) {
      this.login_status = res;
      this.bg = false;
    },
    headswitch(bg, type) {
      this.showtype = type;
      this.bg = bg;
    },
    mobilechange(mobile) {
      this.mobile = mobile;
    },
  },
  mounted() {
    var swiper = new Swiper(".swiper-container", {
      autoplay: {
        delay: 4000,
        disableOnInteraction: false, // 取消鼠标操作后的轮播暂停【无操作轮播继续】【参考链接1】
        stopOnLastSlide: false, // 在最后一页停止
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      speed: 500,
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true,
      loop: true
    });
  },
};
</script>
<style scoped src="./index.css"></style>
